import { useCreate, useUpdate } from '../../../api/react-query';

export function useUpdateCarryLeaves() {
  const { mutateAsync, isLoading } = useCreate({
    url: 'update_employeeold_leave_count_details',
  });
  return {
    updateCarryLeaves: mutateAsync,
    isLoading,
  };
}
